import { Big } from 'big.js';

import { Data, updateProperties } from '../object-utils';

export const getDollarsFromCents = (centsAmount: number): number => new Big(centsAmount).div(100).toNumber();
export const getCentsFromDollars = (dollarsAmount: number): number =>
  new Big(dollarsAmount).mul(100).round(0).toNumber();

export const convertCentsToDollars = <T extends Data, R extends T = T>(object: T, properties: string[]) =>
  updateProperties<T, R>(object, properties, (amount?: number | null) => amount && getDollarsFromCents(amount));

export const convertDollarsToCents = <T extends Data>(object: T, properties: string[]) =>
  updateProperties(object, properties, (amount?: number | null) => amount && getCentsFromDollars(amount));
